import { breakpoints, theme } from '@notino/react-styleguide';

import { Arrow } from '@components/Arrow';
import { styled } from '@linaria/react';

export const REVIEW_SLIDE_DESKTOP_HEIGHT = 590;

export const GallerySection = styled.div`
  position: relative;
  width: 100vw;
  background-color: ${theme.color.background.tertiary};

  @media (min-width: ${breakpoints.md}) {
    width: 50%;
  }
`;

export const Slide = styled.div`
  padding: 0 3rem;
  height: min(100vw, 500px);

  @media (min-width: ${breakpoints.md}) {
    padding: 3rem;
    height: ${REVIEW_SLIDE_DESKTOP_HEIGHT}px;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding: 3rem 100px;
  }
`;

export const SlideImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  display: block;
  margin: auto 0;
  user-select: none;
`;

export const StyledArrow = styled(Arrow)`
  padding: 0.5rem;
  border-radius: 100vw;
  box-shadow: 0px 6px 12px 0px rgba(71, 71, 71, 0.1),
    0px 1px 2px 0px rgba(71, 71, 71, 0.06);

  @media (min-width: ${breakpoints.lg}) {
    padding: 0.75rem;
  }
`;

export const NextReviewArrow = styled(StyledArrow)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
